module.exports = __webpack_public_path__ + "static/media/01.0b595fe4.jpg";